// networkManagment

import { User                 ,
         initializedUser      } from '../userManagment/types';
		 
import { UserAgent            ,
         initializedUserAgent } from '../userAgentManagment/types';

export interface DetailledIpAddressInformations {

  ipAddress              : string      ,
  creationDate           : Date | null ,
  ipApiCom_query         : string      ,
  ipApiCom_status        : string      ,
  ipApiCom_continent     : string      ,
  ipApiCom_continentCode : string      ,
  ipApiCom_country       : string      ,
  ipApiCom_countryCode   : string      ,
  ipApiCom_region        : string      ,
  ipApiCom_regionName    : string      ,
  ipApiCom_city          : string      ,
  ipApiCom_district      : string      ,
  ipApiCom_zip           : string      ,
  ipApiCom_lat           : number      ,
  ipApiCom_lon           : number      ,
  ipApiCom_timezone      : string      ,
  ipApiCom_offset        : number      ,
  ipApiCom_currency      : string      ,
  ipApiCom_isp           : string      ,
  ipApiCom_org           : string      ,
  ipApiCom_as            : string      ,
  ipApiCom_asname        : string      ,
  ipApiCom_reverse       : string      ,
  ipApiCom_mobile        : boolean     ,
  ipApiCom_proxy         : boolean     ,
  ipApiCom_hosting       : boolean     ,
  user                   : User        ,
  userAgent              : UserAgent
}

export const initializedDetailledIpAddressInformations = (): DetailledIpAddressInformations => ( 
 {
  ipAddress              : ""                      ,
  creationDate           : null                    ,
  ipApiCom_query         : ""                      ,
  ipApiCom_status        : ""                      ,
  ipApiCom_continent     : ""                      ,
  ipApiCom_continentCode : ""                      ,
  ipApiCom_country       : ""                      ,
  ipApiCom_countryCode   : ""                      ,
  ipApiCom_region        : ""                      ,
  ipApiCom_regionName    : ""                      ,
  ipApiCom_city          : ""                      ,
  ipApiCom_district      : ""                      ,
  ipApiCom_zip           : ""                      ,
  ipApiCom_lat           : 0                       ,
  ipApiCom_lon           : 0                       ,
  ipApiCom_timezone      : ""                      ,
  ipApiCom_offset        : 0                       ,
  ipApiCom_currency      : ""                      ,
  ipApiCom_isp           : ""                      ,
  ipApiCom_org           : ""                      ,
  ipApiCom_as            : ""                      ,
  ipApiCom_asname        : ""                      ,
  ipApiCom_reverse       : ""                      ,
  ipApiCom_mobile        : false                   ,
  ipApiCom_proxy         : false                   ,
  ipApiCom_hosting       : false                   ,
  user                   : initializedUser ()      ,
  userAgent              : initializedUserAgent ()
});
